export async function updateForeignPersonalInfo(foreignPersonalInfoRepository, foreignPersonalInfo) {
  return foreignPersonalInfoRepository.update(foreignPersonalInfo)
}